import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import AddCircle from '@mui/icons-material/AddCircle';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CircularProgress from '@mui/material/CircularProgress';
import { DateTime } from 'luxon';
import { createSearchParams, useSearchParams, useNavigate } from 'react-router-dom';
import { objectToQueryString, apiHelper, baseUrl } from 'helpers/util';

import ColumnBox from 'components/ColumnBox';
import CardItem from 'components/CardItem';
import CardList from 'components/CardList';
import SmallHeading from 'components/SmallHeading';
import SmallestHeading from 'components/SmallestHeading';

export default function Form() {
    const navigate = useNavigate();
    const [ prevTrainings, setPrevTrainings ] = useState([]);

    const loadPrevTrainings = function() {
        apiHelper.get({ "url": `${baseUrl}/.netlify/functions/erp_custom_api`,
            params: { "route": "folk_training.session_list" } })
        .then(response => {
            if (response.status) {
                for (const t of response.json.message.sessions) {
                    t.session_date = t.session_date ?
                        DateTime.fromISO(t.session_date).toFormat('dd-MMM-yyyy')
                        : t.session_date
                }
                setPrevTrainings(response.json.message.sessions);
            } else {
                console.log(response);
                console.log(response.json);
            }
        })
    }

    const openSessionDetail = function(trainingName) {
        navigate({ "pathname": "/training_index/session_detail",
            "search": createSearchParams({
                'name': trainingName
            }).toString() });
    }

    useEffect(function() {
        loadPrevTrainings();
    }, [])

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center',
            padding: '15px' }}>
            <ColumnBox>
                <SmallHeading>Previous Sessions</SmallHeading>
                <CardList>
                    { prevTrainings.map(p => (
                        <CardItem sx={{ 'cursor': 'pointer' }} onClick={() =>
                            openSessionDetail(p.name)}>
                            <SmallestHeading>{p.taken_by}</SmallestHeading>
                            <Box>{p.session_date}</Box>
                        </CardItem>
                    )) }
                </CardList>
            </ColumnBox>
        </Box>
    );
}
